import { Component, Input } from 'angular-ts-decorators';

import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';
import { includes, pull, indexOf } from 'lodash';

/**
 * Component to build sorting in a table.
 *
 * @example
 * <sw-order-by sw-model="$ctrl.sort" key="fieldName"></sw-order-by>
 */
@Component({
  selector: 'swOrderBy',
  template: require('./sw-order-by.html').default,
})
export class SwOrderByComponent {
  faSort = faSort;
  faSortDown = faSortDown;
  faSortUp = faSortUp;

  direction: string;

  @Input('=') swModel: string[];
  @Input('@') key: string;

  constructor() {
    'ngInject';
  }

  changeSort() {
    if (this.isAscending()) {
      const keyIndex = indexOf(this.swModel, this.key);
      this.swModel[keyIndex] = '-' + this.key;
      return;
    } else if (this.isDescending()) {
      pull(this.swModel, '-' + this.key);
      return;
    }

    this.swModel?.unshift(this.key);
  }

  isAscending() {
    return includes(this.swModel, this.key);
  }

  isDescending() {
    return includes(this.swModel, '-' + this.key);
  }

  isUnsorted() {
    return !this.isDescending() && !this.isAscending();
  }
}
